<template>
    <router-view/>
    <TheModal v-if="storeUI.isShowModal"/>
    <div id="v3d-container" class="wb-v3d-container"></div>
</template>

<script>
import initVerge from '../initVerge';
import { useStoreUI } from '@/Store/storeUI';
import TheModal from '@/UI/TheModal.vue';
import { $ } from '@/Engine/state';
import { requestJson } from '@/libs/httpRequest';
import { urlAPI } from '@/Constants/caseComponentsLib/urlAPI';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { accessoryFileName, glbComponents, glbCToolChests } from '@/Constants/glb';
import { isMobile } from 'mobile-device-detect';
import { savePreset } from '@/libs/savePreset';
import { useStoreItemsFromApi } from '@/Store/storeItemsFromApi';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { getPresets } from '@/libs/getPresets';
import { useStorePresets } from '@/Store/storePresets';
import { onMessageHandler, requestMetaData } from '@/utils/postmessages';
import { useStoreMeta } from '@/Store/storeMeta';

export default {
    name: 'App',
    components: {
        TheModal,
    },
    setup() {
        const storeUI = useStoreUI();
        const storeCaseConfiguration = useStoreCaseConfiguration();
        const storeProjectStructure = useStoreProjectStructure();
        const storeItemsFromApi = useStoreItemsFromApi();
        const storePresets = useStorePresets();
        return {
            storeUI,
            storeCaseConfiguration,
            storeProjectStructure,
            storeItemsFromApi,
            storePresets,
        };
    },
    provide() {
        return {};
    },
    data: function() {
        return {
            init: false,

        };
    },
    computed: {},
    methods: {
        onClickOutside() {
            this.storeUI.setShownTopColorMenu();
            this.storeUI.setIsContestMenuAvailable(false);
        },
    },
    mounted: async function() {
        this.storeProjectStructure.clear();
        console.log('Запрос метаданных');
        window.addEventListener('message', onMessageHandler,false);
        requestMetaData();

        window.save = savePreset;
        $.loader.preloadAssets([
          ...glbCToolChests,
        ]);
        $.loader.enable = true;
        console.log('Инициализация движка');
        await initVerge();
        console.log('подгружаем фоном комплектующие');
        $.loader.preloadAssets([ ...glbComponents ]);
        console.log('подгружаем фоном аксессуары');
        $.loader.preloadAssets([ accessoryFileName ]);

        console.log('Запрос списка продукции');
        const baseURL = window.location.href;
        console.log('baseURL ', baseURL);
        const url = new URL(baseURL);
        url.pathname = urlAPI;
        url.searchParams.set('dealerId', useStoreMeta().dealer);
        url.searchParams.set('city', useStoreMeta().city);
        console.log(url.toString());

        const response =  await requestJson(url.toString());
        console.log(response);
        if (response) {
            const { data } = response;
            this.storeItemsFromApi.uploadApiCatalog(data);
            this.storePresets.loadPresetsCatalog(getPresets(data));
        }

        document.addEventListener('click', this.onClickOutside);

        if (isMobile) {
            this.storeUI.setIsMobile(true);
        }
    },
    beforeUnmount() {
        document.removeEventListener('click', this.onClickOutside);
    },
    unmounted() {
        // window.removeEventListener('message', onMessageHandler);
    },
};
</script>

<style scoped lang="scss">

.wb-v3d-container {
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    z-index: 2;
}
</style>
